export default __webpack_public_path__ + "static/media/GR00062-owl_fara_toca.3d2670e6.svg";